import { render } from "./PopupMoodboard.vue?vue&type=template&id=0e5a34a3&scoped=true"
import script from "./PopupMoodboard.vue?vue&type=script&lang=js"
export * from "./PopupMoodboard.vue?vue&type=script&lang=js"

import "./PopupMoodboard.vue?vue&type=style&index=0&id=0e5a34a3&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5a34a3"]])

export default __exports__